var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencil = function SvgPencil(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8688 2.86883C11.0164 2.71602 11.193 2.59412 11.3882 2.51027C11.5834 2.42642 11.7933 2.38228 12.0058 2.38043C12.2182 2.37859 12.4289 2.41907 12.6256 2.49952C12.8222 2.57997 13.0008 2.69877 13.1511 2.849C13.3013 2.99923 13.4201 3.17787 13.5005 3.37451C13.581 3.57114 13.6215 3.78183 13.6196 3.99427C13.6178 4.20672 13.5736 4.41667 13.4898 4.61188C13.4059 4.80709 13.284 4.98364 13.1312 5.13123L12.4968 5.76563L10.2344 3.50323L10.8688 2.86883ZM9.10322 4.63443L2.40002 11.3376V13.6H4.66242L11.3664 6.89683L9.10242 4.63443H9.10322Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Pencil.7dc25ea81a1e83a792ff09ae1a214ce0.svg";